<template> 
    <div class="col-md-12" style="margin-top: 20px; min-height:720px;">
        <b-container>
        <b-tabs justified content-class="mb-5" style="margin-top:20px;">
            <b-container>
            <b-tab active>
                <template v-slot:title class="">
                    <h5 class="mt-3" style="font-weight: bold; font-family: roboto; font-size:22px; color:#1D1D1D;">FAQs</h5>
                </template>
             
        <b-row class="mt-4">
         <b-container class="mb-4" style="">
            <b-row style="background-color:#565754;">
                <b-col sm="12" class="text-center">
                    <h4 class="mt-3 mb-3" style="color:white; font-weight:700;">FREQUENTLY ASKED QUESTIONS</h4>
                </b-col>
            </b-row>
                 <b-row class="" style="background-color:#F4F4F4;">
                    <b-col class="" sm="12" v-for="(item, index) in loadedData" v-bind:key="index">
                        <b-card no-body class="mb-1 mt-2" style="outline:none; border:none; border-radius:unset; background-color:#F4F4F4;">
                            <b-card-header header-tag="header" class="mt-2 mb-2 p-1" role="tab">
                            <b-button  style="outline:none; font-size:22px; background-color:#F4F4F4; border:none; border-radius:unset; font-weight:600; color:#1D1D1D;" class="d-flex" block href="#" v-b-toggle="'accordion-' + index">
                            <h5 class="" v-for="(index, question) in item" v-bind:key="question" >
                            <span class="ml-n3" style="font-size:20px; font-weight:600;">{{question}}</span>
                            </h5>
                            <strong v-if="currentState" aria-expanded= "true" class="ml-auto">-</strong>
                            <strong v-else aria-expanded="true" class="ml-auto" style="">+</strong>
                            </b-button>
                            </b-card-header>
                       <b-collapse :id="'accordion-' + index" visible accordion="my-accordion" role="tabpanel">
                           <b-card-body class="" style="background-color:#F4F4F4;">
                            <h5 class="" v-for="(question, answer) in item" v-bind:key="answer" >
                              <h5 class="" v-html="question.answer"></h5>
                            </h5>
                        </b-card-body>
                        
                       </b-collapse>
                   </b-card>
                </b-col>
                 </b-row>
         </b-container>
        </b-row>
        </b-tab>
        </b-container>
            <b-container :style="{display: 'none'}">
                <b-tab>
                <template v-slot:title class="">
                    <h5 class="mt-3" style="font-weight: bold; font-family: roboto; font-size:22px; color:#1D1D1D;">User Guide</h5>
                </template>
                <b-col sm="12" class="mt-4">
                    <div v-if="showSecretariatManual" style="margin-top: 0px;">
                            <p style="font-weight:600;">
                            UNEA monitoring and Reporting Portal Manual guides you on the procedures of accessing the portal,
                            Reporting on the Outcomes, Viewing of the reports and PoW reports and other activities.
                            </p>
                             <b-button v-b-modal.modal-xl class="mt-2" style="font-weight: bold; font-family: roboto; font-size:18px; color:white;">Click to play Manual</b-button>
                              <p/>
                              <p>Also available is a pdf guide to the portal:</p>
                              <a href="https://wedocs.unep.org/bitstream/handle/20.500.11822/40642/UNEA_2.pdf?sequence=1&isAllowed=y" target="_blank">View User Guide</a>
                              <p/>
                    <b-modal id="modal-xl" size="xl" title="" hide-footer>
                        <b-embed
                        type="iframe"
                        aspect="16by9"
                        src='https://unea.unep.org/monitoring/manual-sc/story.html'
                        allowfullscreen
                    ></b-embed>
                    </b-modal>
                    </div>
                    <div v-if="showMemberStateManual" style="margin-top: 0px;">
                            <p style="font-weight:600;">
                            UNEA monitoring and Reporting Portal Manual guides you on the procedures of accessing the portal,
                            Reporting on the Outcomes, Viewing of the reports and PoW reports and other activities.
                            </p>
                            <b-button v-b-modal.modal-xl class="mt-2" style="font-weight: bold; font-family: roboto; font-size:18px; color:white;">Click to play Manual</b-button>
                            <p/>

                            <p>Also available is a pdf guide to the portal:</p>
                            <a href="https://wedocs.unep.org/bitstream/handle/20.500.11822/40641/UNEA.pdf?sequence=1&isAllowed=y" target="_blank">View User Guide</a>
                            <p/>

                    <b-modal id="modal-xl" size="xl" title="" hide-footer>
                        <b-embed
                        type="iframe"
                        aspect="16by9"
                        src='https://unea.unep.org/monitoring/manual-ms/story.html'
                        allowfullscreen
                    ></b-embed>
                    </b-modal>
                    </div>
                </b-col>
                </b-tab>
            </b-container>
         </b-tabs>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'Faq',
        components: {},
        data() {
            return {
                loadedData: [],
                apiUrl: process.env.VUE_APP_API_PATH,
                id: null,
                currentState: false,
                toggle: true,
                item: null,
                items:[],
                isProcessing: false,
                processingAction: '',
            }
        },
        computed:{
             showMemberStateManual() {
              
                let loggedInUniteId = document.getElementById('loggedInUniteId');
                if (loggedInUniteId != null && loggedInUniteId.value == '0') {
                    return true;
                }
console.log(loggedInUniteId);
                if(loggedInUniteId == null && window.location.href.indexOf("localhost") >= 0){
                    return true;
                }

                return false;
            },
               showSecretariatManual() {
            
                let loggedInUniteId = document.getElementById('loggedInUniteId');
                if (loggedInUniteId != null && loggedInUniteId.value == '1') {
                    return true;
                }

                if(loggedInUniteId == null && window.location.href.indexOf("localhost") >= 0){
                    return true;
                }

                return false;
            },
             outcomeTitle() {
                try {
                    return this.item.outcome_type_model.outcome_type + " " + this.item.outcome.outcome_code + ": " + this.item.outcome.outcome_name;
                } catch (e) {
                    return "Loading ...";
                }
            }
        },
        created() {
            this.id = this.$route.params.id;
        },
        mounted() {
            this.fetchData()
        },
        methods: {
            fetchData() {
                let url = this.apiUrl;
                fetch(url + '/getfaq/'+document.getElementById('loggedInUniteId').value)
                    .then(res => res.json())
                    .then(res => {
                        this.loadedData = res["data"];
                    });
            },
           
        }
    }
</script>
<style>
.mybutton{
    border-color: transparent!important;
}
.rtable {
  width: 100%;
  counter-reset: row-num;
  border-color: black;
}
.rtable tr {
  counter-increment: row-num;
}
.rtable tr td:first-child::before {
    content: counter(row-num) ". ";
}
    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    border: 4px solid #91C85F!important;
    border-top-left-radius: 0rem;
    border-top-right-radius: 0rem;
    background-color: white!important;
}
.nav-tabs .nav-item {
    border-right: 4px solid white!important;
    background-color: #EBEBEB!important;
    min-height: auto;
    text-align: center;
}
    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    border: 4px solid #91C85F!important;
    border-top-left-radius: 0rem;
    border-top-right-radius: 0rem;
    background-color: white!important;
}
.page-link {
    position: relative;
    display:grid;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #171717!important;
    background-color:#F4F4F4!important;
    border: 5px solid white!important;
}
.page-item.disabled .page-link {
    color: #6c757d!important;
    pointer-events: none;
    cursor: auto;
    background-color:#F4F4F4!important;
    border-color: white!important;
}
.page-item.active .page-link {
    z-index: 3;
    color: #0062FF!important;
    background-color: #82CAFA!important;
    border-color: white!important;
}
.nav-tabs {
    border-bottom: none!important; 
}
.nav-tabs .nav-link {
    border: none!important;
}
.card-header {
    padding: 0!important; 
    margin-bottom: 0;
    outline: none!important;
    background-color: #F4F4F4!important;
    border-bottom: 2px solid rgba(0, 0, 0, 0.125)!important;
}
.btn-secondary:focus, .btn-secondary.focus {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62;
     -webkit-box-shadow: none!important; 
     box-shadow: none!important;
}

</style>